namespace TabAurous.OMS {
    export interface ContactDetailsForm {
        LedgerId: Serenity.IntegerEditor;
        Designation: Serenity.LookupEditor;
        FirstName: Serenity.StringEditor;
        LastName: Serenity.StringEditor;
        Phone: Serenity.StringEditor;
        MobileNo: Serenity.StringEditor;
        EmailId: Serenity.EmailEditor;
        IsDefault: _Ext.YesNoEditor;
        AddtoZiFlow: _Ext.YesNoEditor;
        Comment: Serenity.BooleanEditor;
        Decision: Serenity.BooleanEditor;
        Manage: Serenity.BooleanEditor;
        Share: Serenity.BooleanEditor;
    }

    export class ContactDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.ContactDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ContactDetailsForm.init)  {
                ContactDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;
                var w2 = s.StringEditor;
                var w3 = s.EmailEditor;
                var w4 = _Ext.YesNoEditor;
                var w5 = s.BooleanEditor;

                Q.initFormType(ContactDetailsForm, [
                    'LedgerId', w0,
                    'Designation', w1,
                    'FirstName', w2,
                    'LastName', w2,
                    'Phone', w2,
                    'MobileNo', w2,
                    'EmailId', w3,
                    'IsDefault', w4,
                    'AddtoZiFlow', w4,
                    'Comment', w5,
                    'Decision', w5,
                    'Manage', w5,
                    'Share', w5
                ]);
            }
        }
    }
}
